import { PillsInput as MantinePillsInput, type PillsInputFactory } from "@mantine/core";
import { componentWrapper } from "../../utilities";
import styles from "./pills-input.module.scss";
import type { IProps } from "./pills-input.types";

const PillsInput = componentWrapper<PillsInputFactory, IProps>("PillsInput", (props, ref) => {
    return <MantinePillsInput ref={ref} classNames={{ root: styles["container"] }} {...props} />;
});

PillsInput.Field = MantinePillsInput.Field;

export { PillsInput };
